import React, { useState, useEffect, useRef } from "react";
import {
  MainContainer,
  TitleFormContainer,
  TitleForm,
  FormDescription,
  TitleSection,
  SectionContainer3Columns,
  SectionContainer2Columns,
  ActivePasiveText,
  BackArrowContainer,
  SectionContainer1Column,
  CuentasContainer,
} from "./FormNaturalAllElements";

import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import { Button, FormControl, Typography } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { es } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import InputAdornment from "@mui/material/InputAdornment";

//LOADING COMPONENT
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/system";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import InputLabel from "@mui/material/InputLabel";

import FileUpload from "react-mui-fileuploader";

import { IoArrowBackCircleSharp } from "react-icons/io5";

//signature pad
import Popup from "reactjs-popup";
import "./sigCanvas.css";

import SignaturePad from "react-signature-canvas";

//firebase
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { firebaseApp } from "../../utils/firebase";
import "firebase/compat/storage";
import "firebase/compat/firestore";
//email
import * as emailjs from "@emailjs/browser";

//FORM
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const FormNaturalAll = (props) => {
  emailjs.init("8a6YjyUTerawhlWGO");
  const db = firebase.firestore(firebaseApp);

  let multilineValue =
    "- Autorizo a Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE, a proprocionar directa o indirectamente la información contenida en este formulario y/o una copia de este formulario a cualquier autoridad fiscal pertinente o cualquier parte autorizada, para auditar o realizar un control similiar de Fiduvalor Casa de Valores S. A. para fines fiscales, así como a divulgar a tales autoridades fiscales o tal parte, cualquier información adicional que pudiese poseer Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación. - Acepto que la información contenida en este formulario y la información relacionada con mis cuentas en Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE (incluso la información sobre los saldos de cuentas y pagos recibidos) se notifique a las autoridades fiscales perinentes, y que estas autoridades proporcionen esta información a cualquier otro país enumerado en la lista http://www.oecd.org/tax/automatic-exchange/ como a un país en el cual soy residente para fines fiscales. - Me comprometo a avisar inmediatamente a Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE sobre cualquier cambio en las circunstancias que motive que la información contenida en este documento sea incorrecta y a proporcionar a Fiduvalor Casa de Valores S. A., Depósito Centralizado de Valores (DECEVALE) y Depósito Centralizado de Valores DCV - BCE un formulario actualizado y apropiado de Auto-certificación de Residencia Fiscal en un plazo de 30 días a partir de la fecha del cambio en las circunstancias. Las transacciones que realice con Fiduvalor Casa de Valores S. A. tienen y tendrán fuente y origen lícitos y no provienen ni provendrán de fondos obtenidos de forma ilegal o ilícita, ni tampoco son o serán destinados a ninguna actividad de esta naturaleza o relacionada con la producción, consumo, comercialización de sustancias estupefacientes y sicotrópicas o cualquier otra actividad delictiva tipificada en la Ley Vigente. Eximo a Fiduvalor Casa de Valores S. A., de toda responsabilidad, inclusive frente a terceros, si esta declaratoria fuese falsa o errónea. Renuncio expresamente a ejecutar cualquier acción o pretensión tanto en el ámbito civil, penal como de cualquier otra índole. Autorizo expresamente a Fiduvalor Casa de Valores S. A., a realizar el análisis que considere pertinente e informar documentadamente a las autoridades competentes en caso de presentarse transacciones inusuales e injustificadas.";

  const { setOnItemClickBack, onItemClickBack, setIsNaturalContinueButton } =
    props;

  const [naturalPersonForm, setNaturalPersonForm] = useState({});
  const [isDeliveringToDB, setIsDeviveringToDB] = useState(false);

  //Loading
  const [isLoading, setIsLoading] = useState(false);

  //Condicionales
  const [isMarried, setIsMarried] = useState(false);
  const [isEcuadorian, setIsEcuadorian] = useState(false);
  const [isEu, setIsEu] = useState(false);
  const [isNoEu, setIsNoEu] = useState(false);
  const [isNCuentas, setIsNCuentas] = useState(false);
  const [isNCuentas2, setIsNCuentas2] = useState(false);
  const [hasAccepted, setHasAccepted] = useState(false);
  const [isUnderage, setIsUnderage] = useState(false);
  const [isDeclaring, setIsDeclaring] = useState(false);

  //**************************************** UseState TextField FORMS**********************************************/
  //DATOS GENERALES
  const [namesValue, setNamesValue] = useState("");
  const [lastnamesValue, setLastnamesValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [cipassportValue, setCipassportValue] = useState("");
  const [nacionalidadValue, setNacionalidadValue] = useState("");
  const [estCivilValue, setEstCivilValue] = useState("");
  const [fechaNacimientoValue, setFechaNacimientoValue] = useState(null);
  const [lugarNacimientoValue, setLugarNacimientoValue] = useState("");
  const [nombreConyugeValue, setNombreConyugeValue] = useState("");
  const [ciConyugeValue, setCiConyugeValue] = useState("");
  const [fechaNacimientoConyugeValue, setFechaNacimientoConyugeValue] =
    useState(null);

  // INFORMACIÓN LABORAL
  const [isWorkingValue, setIsWorkingValue] = useState("");
  const [isWorking, setIsWorking] = useState(false);
  const [empresaTrabajaValue, setEmpresaTrabajaValue] = useState("");
  const [cargoEmpresaValue, setCargoEmpresaValue] = useState("");
  const [ciudadTrabajoValue, setCiudadTrabajoValue] = useState("");
  const [direccionTrabajoValue, setDireccionTrabajoValue] = useState("");
  const [profesionValue, setProfesionValue] = useState("");
  const [telefonoTrabajoValue, setTelefonoTrabajoValue] = useState("");
  const [correoTrabajoValue, setCorreoTrabajoValue] = useState("");
  const [negocioPropioValue, setNegocioPropioValue] = useState("");

  //DOMICILIO
  const [paisValue, setPaisValue] = useState("");
  const [provinciaValue, setProvinciaValue] = useState("");
  const [ciudadValue, setCiudadValue] = useState("");
  const [barrioValue, setBarrioValue] = useState("");
  const [direccionValue, setDireccionValue] = useState("");
  const [numeroCasaValue, setNumeroCasaValue] = useState("");
  const [pisoValue, setPisoValue] = useState("");
  const [telefonoConvencionalValue, setTelefonoConvencionalValue] =
    useState("");
  const [telefonoCelularValue, setTelefonoCelularValue] = useState("");
  const [codigoPostalValue, setCodigoPostalValue] = useState("");

  //RESIDENCIA FISCAL
  const [isEuValue, setIsEuValue] = useState("");
  const [
    identificacionContibuyenteSnnValue,
    setIdentificacionContibuyenteSnnValue,
  ] = useState("");
  const [isNoEuValue, setIsNoEuValue] = useState("");
  const [paisNoEuValue, setPaisNoEuValue] = useState("");

  //INFORMACIÓN FINANCIERA

  const [cajaBancosValue, setCajaBancosValue] = useState("");
  const [valorAutosValue, setValorAutosValue] = useState("");
  const [valorInmueblesValue, setValorInmueblesValue] = useState("");
  const [valorInversionesValue, setValorInversionesValue] = useState("");
  const [totalActivosValue, setTotalActivosValue] = useState("");
  const [ingresosMensualesValue, setIngresosMensualesValue] = useState("");

  const [tarjetaCreditoValue, setTarjetaCreditoValue] = useState("");
  const [hipotecasValue, setHipotecasValue] = useState("");
  const [otrosValue, setOtrosValue] = useState("");
  const [totalPasivosValue, setTotalPasivosValue] = useState("");
  const [patrimonioValue, setPatrimonioValue] = useState("");
  const [egresosMensualesValue, setEgresosMensualesValue] = useState("");

  //CUENTAS
  //Cuenta 1
  const [nCuentasValue, setNCuentasValue] = useState("");
  const [institucionFinanciera1Value, setInstitucionFinanciera1Value] =
    useState("");
  const [tipoCuentaValue, setTipoCuentaValue] = useState("");
  const [numeroCuenta1Value, setNumeroCuenta1Value] = useState("");
  //Cuenta 2
  const [institucionFinanciera2Value, setInstitucionFinanciera2Value] =
    useState("");
  const [tipoCuenta2Value, setTipoCuenta2Value] = useState("");
  const [numeroCuenta2Value, setNumeroCuenta2Value] = useState("");

  //PERFIL DE RIESGO
  const [objetoInversionValue, setObjetoInversionValue] = useState("");
  const [necesidadLiquidezValue, setNecesidadLiquidezValue] = useState("");
  const [experienciaValue, setExperienciaValue] = useState("");
  const [plazoInversionValue, setPlazoInversionValue] = useState("");
  const [disponibilidadRecursosValue, setDisponibilidadRecursosValue] =
    useState("");

  //Representado por
  const [representadoPorValue, setRepresentadoPorValue] = useState("");

  // FILES
  const [firmaFileValue, setFirmaFileValue] = useState([]);
  const [nombreCompletoFirmanteValue, setNombreCompletoFirmanteValue] =
    useState("");
  const [cedulaPasaporteFirmanteValue, setCedulaPasaporteFirmanteValue] =
    useState("");
  const [copiaCedulaTitularFileValue, setCopiaCedulaTitularFileValue] =
    useState();
  const [copiaCedulaConyugeFileValue, setCopiaCedulaConyugeFileValue] =
    useState();
  const [copiaPapeletaTitularFileValue, setCopiaPapeletaTitularFileValue] =
    useState();
  const [copiaPapeletaConyugeFileValue, setCopiaPapeletaConyugeFileValue] =
    useState();

  const [copiaPlanillasFileValue, setCopiaPlanillasFileValue] = useState();
  const [
    copiaDeclaracionImpuestosFileValue,
    setCopiaDeclaracionImpuestosFileValue,
  ] = useState();
  const [
    copiaCertificadoBancarioFileValue,
    setCopiaCertificadoBancarioFileValue,
  ] = useState();

  const [declaraImpuestoValue, setDeclaraImpuestoValue] = useState("");

  const [isCargoPublicoValue, setIsCargoPublicoValue] = useState("");

  const [isFamiliarCargoPublicoValue, setIsFamiliarCargoPublicoValue] = useState("");

  const [isTrabajaCargoPublicoValue, setIsTrabajaCargoPublicoValue] = useState("");

  const [correoConyugeValue, setCorreoConyugeValue] = useState("");

  const [actividadEconomicaConyugeValue, setActividadEconomicaConyugeValue] = useState("");


  /* OnChangeTextFields */
  //DATOS GENERALES
  const onNamesChange = (e) => setNamesValue(e.target.value);
  const onLastNamesChange = (e) => setLastnamesValue(e.target.value);
  const onEmailChange = (e) => setEmailValue(e.target.value);
  const onCiPassportChange = (e) => setCipassportValue(e.target.value);
  const onnacionalidadChange = (e) => setNacionalidadValue(e.target.value);
  const onestCivilChange = (e) => setEstCivilValue(e.target.value);
  const onlugarNacimientoChange = (e) =>
    setLugarNacimientoValue(e.target.value);
  const onNombreConyugeChange = (e) => setNombreConyugeValue(e.target.value);
  const onCiConyugeChange = (e) => setCiConyugeValue(e.target.value);
  const onCorreoConyugeChange = (e) => setCorreoConyugeValue(e.target.value);
  const onActividadEconomicaConyugeChange = (e) => setActividadEconomicaConyugeValue(e.target.value);

  // INFORMACIÓN LABORAL
  const onIsWorkingChange = (e) => setIsWorkingValue(e.target.value);
  const onEmpresaTrabajaChange = (e) => setEmpresaTrabajaValue(e.target.value);
  const oncargoEmpresaChange = (e) => setCargoEmpresaValue(e.target.value);
  const onCiudadTrabajoChange = (e) => setCiudadTrabajoValue(e.target.value);
  const onDireccionTrabajoChange = (e) =>
    setDireccionTrabajoValue(e.target.value);
  const onProfesionChange = (e) => setProfesionValue(e.target.value);
  const onTelefonoTrabajoChange = (e) =>
    setTelefonoTrabajoValue(e.target.value);
  const onCorreoTrabajoChange = (e) => setCorreoTrabajoValue(e.target.value);
  const onNegocioPropioChange = (e) => setNegocioPropioValue(e.target.value);

  //DOMICILIO
  const onPaisChange = (e) => setPaisValue(e.target.value);
  const onProvinciaChange = (e) => setProvinciaValue(e.target.value);
  const onCiudadChange = (e) => setCiudadValue(e.target.value);
  const onBarrioChange = (e) => setBarrioValue(e.target.value);
  const onDireccionChange = (e) => setDireccionValue(e.target.value);
  const onNumeroCasaChange = (e) => setNumeroCasaValue(e.target.value);
  const onPisoChange = (e) => setPisoValue(e.target.value);
  const onTelefonoConvencionalChange = (e) =>
    setTelefonoConvencionalValue(e.target.value);
  const onTelefonoCelularChange = (e) =>
    setTelefonoCelularValue(e.target.value);
  const onCodigoPostalChange = (e) => setCodigoPostalValue(e.target.value);

  //RESIDENCIA FISCAL
  const onIsEuValueChange = (e) => setIsEuValue(e.target.value);
  const onIdentificacionContribuyenteSnnChange = (e) =>
    setIdentificacionContibuyenteSnnValue(e.target.value);
  const onIsNoEuChange = (e) => setIsNoEuValue(e.target.value);
  const onPaisNoEuChange = (e) => setPaisNoEuValue(e.target.value);

  //INFORMACIÓN FINANCIERA
  const onCajaBancosChange = (e) => setCajaBancosValue(e.target.value);

  const onValorAutosChange = (e) => setValorAutosValue(e.target.value);
  const onValorInmueblesChange = (e) => setValorInmueblesValue(e.target.value);
  const onValorInversionesChange = (e) =>
    setValorInversionesValue(e.target.value);

  const onIngresosMensualesChange = (e) =>
    setIngresosMensualesValue(e.target.value);

  const onEgresosMensualesChange = (e) =>
    setEgresosMensualesValue(e.target.value);

  const onTarjetaCreditoChange = (e) => setTarjetaCreditoValue(e.target.value);
  const onHipotecasChange = (e) => setHipotecasValue(e.target.value);
  const onOtrosChange = (e) => setOtrosValue(e.target.value);

  //CUENTAS
  //Cuenta1
  const onNCuentasChange = (e) => setNCuentasValue(e.target.value);
  const onInstitucionFinanciera1Change = (e) =>
    setInstitucionFinanciera1Value(e.target.value);
  const onTipoCuentaChange = (e) => setTipoCuentaValue(e.target.value);
  const onNumeroCuenta1Change = (e) => setNumeroCuenta1Value(e.target.value);

  //Cuenta2
  const onInstitucionFinanciera2Change = (e) =>
    setInstitucionFinanciera2Value(e.target.value);
  const onTipoCuenta2Change = (e) => setTipoCuenta2Value(e.target.value);
  const onNumeroCuenta2Change = (e) => setNumeroCuenta2Value(e.target.value);

  //PERFIL DE RIESGO
  const onObjetoInversionChange = (e) =>
    setObjetoInversionValue(e.target.value);
  const onNecesidadLiquidezChange = (e) =>
    setNecesidadLiquidezValue(e.target.value);
  const onExperienciaValue = (e) => setExperienciaValue(e.target.value);
  const onPlazoInversionChange = (e) => setPlazoInversionValue(e.target.value);
  const onDisponibilidadRecursosChange = (e) =>
    setDisponibilidadRecursosValue(e.target.value);

  const onRepresentadoChange = (e) => setRepresentadoPorValue(e.target.value);

  //FILES
  const onNombreCompletoFirmanteChange = (e) =>
    setNombreCompletoFirmanteValue(e.target.value);
  const onCedulaPasaporteFirmanteChange = (e) =>
    setCedulaPasaporteFirmanteValue(e.target.value);

  const onDeclaraImpuestoChange = (e) =>
    setDeclaraImpuestoValue(e.target.value);

  const onIsCargoPublicoChange = (e) => setIsCargoPublicoValue(e.target.value);

  const onIsFamiliarCargoPublicoChange = (e) => setIsFamiliarCargoPublicoValue(e.target.value);

  const onIsTrabajaCargoPublicoValueChange = (e) => setIsTrabajaCargoPublicoValue(e.target.value);


  useEffect(() => {
    if (estCivilValue === "Casado/a") {
      setIsMarried(true);
    } else {
      setIsMarried(false);
    }
  }, [estCivilValue]);

  useEffect(() => {
    if (isWorkingValue === "Si") {
      setIsWorking(true);
    } else {
      setIsWorking(false);
    }
  }, [isWorkingValue]);

  useEffect(() => {
    if (
      paisValue === "Ecuador" ||
      paisValue === "ecuador" ||
      paisValue === "ecu" ||
      paisValue === "Ecu" ||
      paisValue === "ec" ||
      paisValue === "EC"
    ) {
      setIsEcuadorian(false);
    } else {
      setIsEcuadorian(true);
    }
  }, [paisValue]);

  useEffect(() => {
    if (isEuValue === "Si") {
      setIsEu(true);
    } else {
      setIsEu(false);
    }
  }, [isEuValue]);

  useEffect(() => {
    if (isNoEuValue === "Si") {
      setIsNoEu(true);
    } else {
      setIsNoEu(false);
    }
  }, [isNoEuValue]);
  useEffect(() => {
    if (declaraImpuestoValue === "Si") {
      setIsDeclaring(true);
    } else {
      setIsDeclaring(false);
    }
  }, [declaraImpuestoValue]);

  useEffect(() => {
    setTotalActivosValue(
      Number(cajaBancosValue) +
        Number(valorAutosValue) +
        Number(valorInmueblesValue) +
        Number(valorInversionesValue)
    );
  }, [
    valorAutosValue,
    valorInmueblesValue,
    cajaBancosValue,
    valorInversionesValue,
  ]);

  useEffect(() => {
    setTotalPasivosValue(
      Number(tarjetaCreditoValue) + Number(hipotecasValue) + Number(otrosValue)
    );
  }, [tarjetaCreditoValue, hipotecasValue, otrosValue]);

  useEffect(() => {
    setPatrimonioValue(Number(totalActivosValue) - Number(totalPasivosValue));
  }, [totalPasivosValue, totalActivosValue]);

  useEffect(() => {
    if (nCuentasValue === "1") {
      setIsNCuentas(true);
      setIsNCuentas2(false);
    } else if (nCuentasValue === "2") {
      setIsNCuentas2(true);
      setIsNCuentas(false);
    }
  }, [nCuentasValue]);

  useEffect(() => {
    let hoy = new Date();
    let fechaNacimiento = new Date(fechaNacimientoValue);
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
    if (
      diferenciaMeses < 0 ||
      (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
    ) {
      edad--;
    }
    if (edad < 18) {
      setIsUnderage(true);
    } else {
      setIsUnderage(false);
    }
  }, [fechaNacimientoValue]);

  //Uploading all to firebase
  const uploadAll = async () => {
    let fileData = [];
    setProgress((prevProgress) => prevProgress + 5);
    //SUBIR FIRMA
    if (typeof firmaFileValue !== "undefined" && firmaFileValue.length > 0) {
      await firebase
        .storage()
        .ref(`/naturalform/firmas/${cipassportValue}_FIRMA`)
        .put(firmaFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/naturalform/firmas/${cipassportValue}_FIRMA`)
            .getDownloadURL()
            .then((url) => {
              fileData[0] = url;
            })
            .catch(() => {
              fileData[0] = "";
            });
        });
    } else {
      fileData[0] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //Firma Realizada en app
    if (typeof imageURL === "string") {
      await firebase
        .storage()
        .ref(`/naturalform/firmas/${cipassportValue}_FIRMA`)
        .putString(imageURL, "data_url")
        .then(async () => {
          await firebase
            .storage()
            .ref(`/naturalform/firmas/${cipassportValue}_FIRMA`)
            .getDownloadURL()
            .then((url) => {
              fileData[0] = url;
            })
            .catch(() => {
              fileData[0] = "";
            });
        });
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR CEDULA TITULAR

    if (
      typeof copiaCedulaTitularFileValue !== "undefined" &&
      copiaCedulaTitularFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(
          `/naturalform/copiacedula/cedulatitular/${cipassportValue}_CEDULA_TITULAR`
        )
        .put(copiaCedulaTitularFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/naturalform/copiacedula/cedulatitular/${cipassportValue}_CEDULA_TITULAR`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[1] = url;
            })
            .catch(() => {
              fileData[1] = "";
            });
        });
    } else {
      fileData[1] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR CEDULA CÓNYUGE
    if (
      typeof copiaCedulaConyugeFileValue !== "undefined" &&
      copiaCedulaConyugeFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(
          `/naturalform/copiacedula/cedulaconyuge/${cipassportValue}_CEDULA_CONYUGE`
        )
        .put(copiaCedulaConyugeFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/naturalform/copiacedula/cedulaconyuge/${cipassportValue}_CEDULA_CONYUGE`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[2] = url;
            })
            .catch(() => {
              fileData[2] = "";
            });
        });
    } else {
      fileData[2] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR PAPELETA TITULAR
    if (
      typeof copiaPapeletaTitularFileValue !== "undefined" &&
      copiaPapeletaTitularFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(
          `/naturalform/copiapapeleta/papeletatitular/${cipassportValue}_PAPELETA_TITULAR`
        )
        .put(copiaPapeletaTitularFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/naturalform/copiapapeleta/papeletatitular/${cipassportValue}_PAPELETA_TITULAR`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[3] = url;
            })
            .catch(() => {
              fileData[3] = "";
            });
        });
    } else {
      fileData[3] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR PAPELETA CÓNYUGE
    if (
      typeof copiaPapeletaConyugeFileValue !== "undefined" &&
      copiaPapeletaConyugeFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(
          `/naturalform/copiapapeleta/papeletaconyuge/${cipassportValue}_PAPELETA_CONYUGE`
        )
        .put(copiaPapeletaConyugeFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(
              `/naturalform/copiapapeleta/papeletaconyuge/${cipassportValue}_PAPELETA_CONYUGE`
            )
            .getDownloadURL()
            .then((url) => {
              fileData[4] = url;
            })
            .catch(() => {
              fileData[4] = "";
            });
        });
    } else {
      fileData[4] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR COPIA DE PLANILLA
    if (
      typeof copiaPlanillasFileValue !== "undefined" &&
      copiaPlanillasFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/naturalform/copiaplanilla/${cipassportValue}_PLANILLA`)
        .put(copiaPlanillasFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/naturalform/copiaplanilla/${cipassportValue}_PLANILLA`)
            .getDownloadURL()
            .then((url) => {
              fileData[5] = url;
            })
            .catch(() => {
              fileData[5] = "";
            });
        });
    } else {
      fileData[5] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);

    //SUBIR DECLARACION SRI
    if (
      typeof copiaDeclaracionImpuestosFileValue !== "undefined" &&
      copiaDeclaracionImpuestosFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/naturalform/copiadeclaracion/${cipassportValue}_DECLARACION`)
        .put(copiaDeclaracionImpuestosFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/naturalform/copiadeclaracion/${cipassportValue}_DECLARACION`)
            .getDownloadURL()
            .then((url) => {
              fileData[6] = url;
            })
            .catch(() => {
              fileData[6] = "";
            });
        });
    } else {
      fileData[6] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 15);

    //SUBIR CERTIFICADO BANCARIO

    if (
      typeof copiaCertificadoBancarioFileValue !== "undefined" &&
      copiaCertificadoBancarioFileValue.length > 0
    ) {
      await firebase
        .storage()
        .ref(`/naturalform/copiacertificado/${cipassportValue}_CERTIFICADO`)
        .put(copiaCertificadoBancarioFileValue[0])
        .then(async () => {
          await firebase
            .storage()
            .ref(`/naturalform/copiacertificado/${cipassportValue}_CERTIFICADO`)
            .getDownloadURL()
            .then((url) => {
              fileData[7] = url;
            })
            .catch(() => {
              fileData[7] = "";
            });
        });
    } else {
      fileData[7] = "No envió";
    }
    setProgress((prevProgress) => prevProgress + 5);


    //Enviar a colección y crear usuario auth

    await firebase
      .auth()
      .createUserWithEmailAndPassword(emailValue, emailValue)
      .catch((error) => {
        //handle errors
        var errorCode = error.code;
        if (errorCode == "auth/email-already-in-use") {
          console.log("Email en uso");
        } else {
          console.log("Email no en uso");
        }
      })
      .then(async () => {
        setProgress((prevProgress) => prevProgress + 15);
        await new Promise((r) => setTimeout(r, 5000));
        setProgress((prevProgress) => prevProgress + 15);
        await db.collection("naturalPersonCollection").add({
          Nombres: namesValue,
          Apellidos: lastnamesValue,
          CorreoElectronico: emailValue,
          CedulaoPasaporte: cipassportValue,
          Nacionalidad: nacionalidadValue,
          EstadoCivil: estCivilValue,
          FechaNacimiento: fechaNacimientoValue,
          LugarNacimiento: lugarNacimientoValue,
          NombreConyuge: nombreConyugeValue,
          CedulaoPasaporteConyuge: ciConyugeValue,
          CorreoConyuge: correoConyugeValue,
          ActividadEconomicaConyuge: actividadEconomicaConyugeValue,
          FechaNacimientoConyuge: fechaNacimientoConyugeValue,
          Trabaja: isWorkingValue,
          EmpresaDondeTrabaja: empresaTrabajaValue,
          CargoEmpresa: cargoEmpresaValue,
          CiudadTrabajo: ciudadTrabajoValue,
          DireccionTrabajo: direccionTrabajoValue,
          Profesion: profesionValue,
          TelefonoTrabajo: telefonoTrabajoValue,
          CorreoTrabajo: correoTrabajoValue,
          NegocioPropio: negocioPropioValue,
          Pais: paisValue,
          Provincia: provinciaValue,
          Ciudad: ciudadValue,
          Barrio: barrioValue,
          Direccion: direccionValue,
          NumeroDeCasa: numeroCasaValue,
          PisoDepartamento: pisoValue,
          TelefonoConvencional: telefonoConvencionalValue,
          TelefonoCelular: telefonoCelularValue,
          CodigoPostal: codigoPostalValue,
          PersonaEstadoUnidenseParaFinesFiscales: isEuValue,
          IdentificacionContribuyenteSnn: identificacionContibuyenteSnnValue,
          ResidentePaisDistintoEUFinesFiscales: isNoEuValue,
          PaisResidenteDistintoEuFinesFiscales: paisNoEuValue,
          CargoPublico: isCargoPublicoValue,
          FamiliarCargoPublico: isFamiliarCargoPublicoValue,
          TrabajaCargoPublico: isTrabajaCargoPublicoValue,
          CajaoBancos: cajaBancosValue,
          ValorEnAutos: valorAutosValue,
          ValorEnInmuebles: valorInmueblesValue,
          ValorEnInversiones: valorInversionesValue,
          TotalActivos: totalActivosValue,
          IngresosMensuales: ingresosMensualesValue,
          TarjetaDeCredito: tarjetaCreditoValue,
          Hipotecas: hipotecasValue,
          OtrosPasivo: otrosValue,
          Patrimonio: patrimonioValue,
          EgresosMensuales: egresosMensualesValue,
          InstitucionFinancieraCuenta1: institucionFinanciera1Value,
          TipoDeCuenta1: tipoCuentaValue,
          NumeroDeCuenta1: numeroCuenta1Value,
          InstitucionFinancieraCuenta2: institucionFinanciera2Value,
          TipoDeCuenta2: tipoCuenta2Value,
          NumeroDeCuenta2: numeroCuenta2Value,
          ObjetoDeInversion: objetoInversionValue,
          NecesidadDeLiquidez: necesidadLiquidezValue,
          Experiencia: experienciaValue,
          PlazoDeInversion: plazoInversionValue,
          DisponibilidadRecursos: disponibilidadRecursosValue,
          RepresentadoPor: representadoPorValue,
          Firma: fileData[0],
          NombreCompletoFirmante: nombreCompletoFirmanteValue,
          CedulaPasaporteFirmante: cedulaPasaporteFirmanteValue,
          CopiaCedulaTitular: fileData[1],
          CopiaCedulaConyuge: fileData[2],
          CopiaPapeletaVotacionTitular: fileData[3],
          CopiaPapeletaVotacionConyuge: fileData[4],
          CopiaPlanillas: fileData[5],
          CopiaDeclaracionImpuestos: fileData[6],
          CopiaCertificadoBancario: fileData[7],
          FechaDeEnvio: new Date(),
          Tag: "Clientes",
        });
        setProgress((prevProgress) => prevProgress + 5);
      })
      .then(() => {
        setNaturalPersonForm({
          Nombres: namesValue,
          Apellidos: lastnamesValue,
          CorreoElectronico: emailValue,
          CedulaoPasaporte: cipassportValue,
          Nacionalidad: nacionalidadValue,
          EstadoCivil: estCivilValue,
          FechaNacimiento: fechaNacimientoValue,
          LugarNacimiento: lugarNacimientoValue,
          NombreConyuge: nombreConyugeValue,
          CedulaoPasaporteConyuge: ciConyugeValue,
          CorreoConyuge: correoConyugeValue,
          ActividadEconomicaConyuge: actividadEconomicaConyugeValue,
          FechaNacimientoConyuge: fechaNacimientoConyugeValue,
          Trabaja: isWorkingValue,
          EmpresaDondeTrabaja: empresaTrabajaValue,
          CargoEmpresa: cargoEmpresaValue,
          CiudadTrabajo: ciudadTrabajoValue,
          DireccionTrabajo: direccionTrabajoValue,
          Profesion: profesionValue,
          TelefonoTrabajo: telefonoTrabajoValue,
          CorreoTrabajo: correoTrabajoValue,
          NegocioPropio: negocioPropioValue,
          Pais: paisValue,
          Provincia: provinciaValue,
          Ciudad: ciudadValue,
          Barrio: barrioValue,
          Direccion: direccionValue,
          NumeroDeCasa: numeroCasaValue,
          PisoDepartamento: pisoValue,
          TelefonoConvencional: telefonoConvencionalValue,
          TelefonoCelular: telefonoCelularValue,
          CodigoPostal: codigoPostalValue,
          PersonaEstadoUnidenseParaFinesFiscales: isEuValue,
          IdentificacionContribuyenteSnn: identificacionContibuyenteSnnValue,
          ResidentePaisDistintoEUFinesFiscales: isNoEuValue,
          PaisResidenteDistintoEuFinesFiscales: paisNoEuValue,
          CargoPublico: isCargoPublicoValue,
          FamiliarCargoPublico: isFamiliarCargoPublicoValue,
          TrabajaCargoPublico: isTrabajaCargoPublicoValue,
          CajaoBancos: cajaBancosValue,
          ValorEnAutos: valorAutosValue,
          ValorEnInmuebles: valorInmueblesValue,
          ValorEnInversiones: valorInversionesValue,
          TotalActivos: totalActivosValue,
          IngresosMensuales: ingresosMensualesValue,
          TarjetaDeCredito: tarjetaCreditoValue,
          Hipotecas: hipotecasValue,
          OtrosPasivo: otrosValue,
          Patrimonio: patrimonioValue,
          EgresosMensuales: egresosMensualesValue,
          InstitucionFinancieraCuenta1: institucionFinanciera1Value,
          TipoDeCuenta1: tipoCuentaValue,
          NumeroDeCuenta1: numeroCuenta1Value,
          InstitucionFinancieraCuenta2: institucionFinanciera2Value,
          TipoDeCuenta2: tipoCuenta2Value,
          NumeroDeCuenta2: numeroCuenta2Value,
          ObjetoDeInversion: objetoInversionValue,
          NecesidadDeLiquidez: necesidadLiquidezValue,
          Experiencia: experienciaValue,
          PlazoDeInversion: plazoInversionValue,
          DisponibilidadRecursos: disponibilidadRecursosValue,
          RepresentadoPor: representadoPorValue,
          Firma: fileData[0],
          NombreCompletoFirmante: nombreCompletoFirmanteValue,
          CedulaPasaporteFirmante: cedulaPasaporteFirmanteValue,
          CopiaCedulaTitular: fileData[1],
          CopiaCedulaConyuge: fileData[2],
          CopiaPapeletaVotacionTitular: fileData[3],
          CopiaPapeletaVotacionConyuge: fileData[4],
          CopiaPlanillas: fileData[5],
          CopiaDeclaracionImpuestos: fileData[6],
          CopiaCertificadoBancario: fileData[7],
          FechaDeEnvio: new Date(),
        });
        setProgress((prevProgress) => prevProgress + 5);
        setIsLoading(false);
        setIsDeviveringToDB(true);
        setTimeout(() => {
          window.location.href = "www.fiduvalor.com.ec";
        }, 3000);
      })
      .catch((error) => {
        console.log(error);
        alert("Se ha producido un error. Inténtelo más tarde.");
      });
  };

  //Send Email

  const sendEmailForm = () => {
    emailjs
      .send(
        "service_5ubgeq3",
        "template_y3nhoar",
        naturalPersonForm,
        "8a6YjyUTerawhlWGO"
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };

  useEffect(() => {
    isDeliveringToDB && sendEmailForm();
  }, [isDeliveringToDB]);

  //Signature pad
  const [imageURL, setImageURL] = useState(null); // create a state that will contain our image url

  const sigCanvas = useRef({});

  /* a function that uses the canvas ref to clear the canvas 
  via a method given by react-signature-canvas */
  const clear = () => {
    sigCanvas.current.clear();
  };

  const deleteSignature = () => {
    setImageURL(null);
    setDisableIfMadeSignature(false);
  };

  /* a function that uses the canvas ref to trim the canvas 
  from white spaces via a method given by react-signature-canvas
  then saves it in our state */
  const save = () => {
    setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    setDisableIfMadeSignature(true);
  };

  const firstRender = useRef(true);

  const [disableIfUploadSignature, setDisableIfUploadSignature] =
    useState(false);

  const [disableIfMadeSignature, setDisableIfMadeSignature] = useState(false);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (firmaFileValue.length === 0) {
        setDisableIfUploadSignature(false);
      } else {
        setDisableIfUploadSignature(true);
      }
    }
  }, [firmaFileValue]);

  //VALIDATIONS
  const validationSchema = Yup.object().shape({
    names: Yup.string().required("Necesita Completar Este Campo"),
    lastnames: Yup.string().required("Necesita Completar Este Campo"),
    email: Yup.string()
      .required("Necesita Completar Este Campo")
      .email("No es un correo válido"),
    cipassport: Yup.string().required("Necesita Completar Este Campo"),
    nationality: Yup.string().required("Necesita Completar Este Campo"),
    estcivil: Yup.string().required("Necesita Completar Este Campo"),
    lnacimiento: Yup.string().required("Necesita Completar Este Campo"),
    trabaja: Yup.string().required("Necesita Completar Este Campo"),
    pais: Yup.string().required("Necesita Completar Este Campo"),
    provincia: Yup.string().required("Necesita Completar Este Campo"),
    ciudad: Yup.string().required("Necesita Completar Este Campo"),
    barrio: Yup.string().required("Necesita Completar Este Campo"),
    direccion: Yup.string().required("Necesita Completar Este Campo"),
    numerocasa: Yup.string().required("Necesita Completar Este Campo"),
    pisodepartamento: Yup.string().required("Necesita Completar Este Campo"),
    telefonoconvencional: Yup.string().required(
      "Necesita Completar Este Campo"
    ),
    telefonocelular: Yup.string().required("Necesita Completar Este Campo"),
    cajabanco: Yup.string().required("Necesita Completar Este Campo"),
    valorautos: Yup.string().required("Necesita Completar Este Campo"),
    valorinmuebles: Yup.string().required("Necesita Completar Este Campo"),
    valorinversion: Yup.string().required("Necesita Completar Este Campo"),
    ingresosmensuales: Yup.string().required("Necesita Completar Este Campo"),
    tarjetas: Yup.string().required("Necesita Completar Este Campo"),
    hipotecas: Yup.string().required("Necesita Completar Este Campo"),
    otros: Yup.string().required("Necesita Completar Este Campo"),
    egresosmensuales: Yup.string().required("Necesita Completar Este Campo"),
    ncuentas: Yup.string().required("Necesita Completar Este Campo"),
    objinversion: Yup.string().required("Necesita Completar Este Campo"),
    necesidadliquidez: Yup.string().required("Necesita Completar Este Campo"),
    experiencia: Yup.string().required("Necesita Completar Este Campo"),
    plazoinversion: Yup.string().required("Necesita Completar Este Campo"),
    disponibilidadrecursos: Yup.string().required(
      "Necesita Completar Este Campo"
    ),
    nfirmante: Yup.string().required("Necesita Completar Este Campo"),
    cifirmante: Yup.string().required("Necesita Completar Este Campo"),
    declaraimpuesto: Yup.string().required("Necesita Completar Este Campo"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = () => {
    setIsLoading(true);
    setUpload(true);
  };

  const firstRenderUpload = useRef(true);

  const [upload, setUpload] = useState(false);

  useEffect(() => {
    if (firstRenderUpload.current) {
      firstRenderUpload.current = false;
    } else {
      if (upload) {
        uploadAll();
      }
    }
  }, [upload]);

  const [progress, setProgress] = useState(0);

  return (
    <MainContainer style={{ display: onItemClickBack && "none" }}>
      {/* Title and Description */}
      <TitleFormContainer>
        <TitleForm>FORMULARIO {"\n"} PERSONA NATURAL</TitleForm>
        <FormDescription>
          Completa el siguiente{"\n"} formulario con tus datos
        </FormDescription>
      </TitleFormContainer>
      <form name="form" id="form" onSubmit={handleSubmit(onSubmit)}>
        {/************* DATOS GENERALES *****************/}
        <TitleSection>
          Datos Generales
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="names"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Nombres"
              {...register("names")}
              error={errors.names ? true : false}
              onBlur={onNamesChange}
            />
            <Typography variant="inherit" color="red">
              {errors.names?.message}
            </Typography>
          </div>

          <div>
            <TextField
              autoComplete="new-password"
              name="lastnames"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Apellidos"
              {...register("lastnames")}
              error={errors.lastnames ? true : false}
              onBlur={onLastNamesChange}
            />
            <Typography variant="inherit" color="red">
              {errors.lastnames?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="email"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Correo Electrónico"
              {...register("email")}
              error={errors.email ? true : false}
              onBlur={onEmailChange}
            />
            <Typography variant="inherit" color="red">
              {errors.email?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="cipassport"
              style={{ width: "100%" }}
              id="outlined-required"
              label="C.C / Pasaporte"
              {...register("cipassport")}
              error={errors.cipassport ? true : false}
              onBlur={onCiPassportChange}
            />
            <Typography variant="inherit" color="red">
              {errors.cipassport?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="nationality"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Nacionalidad"
              {...register("nationality")}
              error={errors.nationality ? true : false}
              onBlur={onnacionalidadChange}
            />
            <Typography variant="inherit" color="red">
              {errors.nationality?.message}
            </Typography>
          </div>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                Estado Civil
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="estcivil"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Estado Civil"
                MenuProps={{ disableScrollLock: true }}
                {...register("estcivil")}
                error={errors.estcivil ? true : false}
                value={estCivilValue}
                onChange={onestCivilChange}
              >
                <MenuItem value="Soltero/a">Soltero/a</MenuItem>
                <MenuItem value="Casado/a">Casado/a</MenuItem>
                <MenuItem value="Divorciado/a">Divorciado/a</MenuItem>
                <MenuItem value="Viudo/a">Viudo/a</MenuItem>
              </Select>
            </FormControl>

            <Typography variant="inherit" color="red">
              {errors.estcivil?.message}
            </Typography>
          </div>

          <LocalizationProvider dateAdapter={AdapterDayjs} locale={es}>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              disableFuture
              label="Fecha de Nacimiento"
              value={fechaNacimientoValue}
              onChange={(newValue) => {
                let fecha = new Date(newValue);
                setFechaNacimientoValue(fecha);
              }}
              renderInput={(params) => (
                <TextField
                  style={{ width: "100%" }}
                  {...params}
                  name="fnacimiento"
                />
              )}
            />
          </LocalizationProvider>

          <div>
            <TextField
              autoComplete="new-password"
              name="lnacimiento"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Lugar de Nacimiento"
              {...register("lnacimiento")}
              error={errors.lnacimiento ? true : false}
              onBlur={onlugarNacimientoChange}
            />
            <Typography variant="inherit" color="red">
              {errors.lnacimiento?.message}
            </Typography>
          </div>

          {/* ¿¿¿¿¿¿¿¿¿¿¿¿ Está casado???????????? */}
          {isMarried && (
            <>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="nconyuge"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Nombre Completo de Cónyuge"
                  {...register("nconyuge")}
                  onBlur={onNombreConyugeChange}
                />
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="ciconyuge"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="C.C / Pasaporte de Cónyuge"
                  {...register("ciconyuge")}
                  onBlur={onCiConyugeChange}
                />
              </div>

              <LocalizationProvider dateAdapter={AdapterDayjs} locale={es}>
                <DatePicker
                  disableFuture
                  inputFormat="dd/MM/yyyy"
                  label="Fecha Nacimiento(Cónyuge)"
                  value={fechaNacimientoConyugeValue}
                  onChange={(newValue) => {
                    let fecha = new Date(newValue);
                    setFechaNacimientoConyugeValue(fecha);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="correoconyuge"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Correo Electrónico (Cónyuge)"
                  {...register("correoconyuge")}
                  onBlur={onCorreoConyugeChange}
                />
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="actividadeconomicaconyuge"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Actividad Económica (Cónyuge)"
                  {...register("actividadeconomicaconyuge")}
                  onBlur={onActividadEconomicaConyugeChange}
                />
                </div>
            </>
          )}
        </SectionContainer3Columns>
        {/************* INFORMACIÓN LABORAL *****************/}
        <TitleSection>
          Información Laboral
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          {/*¿¿¿¿¿ Está trabajando?????????? */}
          <FormControl style={{ width: "100%" }}>
            <InputLabel id="demo-simple-select-label">
              ¿Trabaja Actualmente?
            </InputLabel>
            <Select
              style={{ width: "100%" }}
              name="trabaja"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="¿Trabaja Actualmente?"
              MenuProps={{ disableScrollLock: true }}
              {...register("trabaja")}
              error={errors.trabaja ? true : false}
              value={isWorkingValue}
              onChange={onIsWorkingChange}
            >
              <MenuItem value="Si">Si</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
            <Typography variant="inherit" color="red">
              {errors.trabaja?.message}
            </Typography>
          </FormControl>
          {isWorking && (
            <>
              <TextField
                autoComplete="new-password"
                name="empresatrabajo"
                style={{ width: "100%" }}
                id="outlined-required"
                label="Empresa donde Trabaja"
                {...register("empresatrabajo")}
                onBlur={onEmpresaTrabajaChange}
              />

              <TextField
                autoComplete="new-password"
                name="cargotrabajo"
                style={{ width: "100%" }}
                id="outlined-required"
                label="Cargo"
                {...register("cargotrabajo")}
                onBlur={oncargoEmpresaChange}
              />
              <TextField
                autoComplete="new-password"
                name="ciudadtrabajo"
                style={{ width: "100%" }}
                id="outlined-required"
                label="Ciudad de Trabajo"
                {...register("ciudadtrabajo")}
                onBlur={onCiudadTrabajoChange}
              />
              <TextField
                autoComplete="new-password"
                name="direcciontrabajo"
                style={{ width: "100%" }}
                id="outlined-required"
                label="Dirección de Trabajo"
                {...register("direcciontrabajo")}
                onBlur={onDireccionTrabajoChange}
              />
              <TextField
                autoComplete="new-password"
                name="profesion"
                style={{ width: "100%" }}
                id="outlined-required"
                label="Profesión"
                {...register("profesion")}
                onBlur={onProfesionChange}
              />
              <TextField
                autoComplete="new-password"
                name="telefonotrabajo"
                style={{ width: "100%" }}
                type="tel"
                id="outlined-required"
                label="Teléfono de Trabajo"
                {...register("telefonotrabajo")}
                onBlur={onTelefonoTrabajoChange}
              />
              <TextField
                autoComplete="new-password"
                name="correotrabajo"
                style={{ width: "100%" }}
                id="outlined-required"
                label="Correo de Trabajo"
                {...register("correotrabajo")}
                onBlur={onCorreoTrabajoChange}
              />
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    ¿Tiene Negocio Propio?
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="negociopropio"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select-helper"
                    label="¿Tiene Negocio Propio?"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("negociopropio")}
                    value={negocioPropioValue}
                    onChange={onNegocioPropioChange}
                  >
                    <MenuItem value="Si">Si</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </>
          )}
        </SectionContainer3Columns>
        {/************* DOMICILIO *****************/}
        <TitleSection>
          Domicilio
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="pais"
              style={{ width: "100%" }}
              id="outlined-required"
              label="País"
              {...register("pais")}
              error={errors.pais ? true : false}
              onBlur={onPaisChange}
            />
            <Typography variant="inherit" color="red">
              {errors.pais?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="provincia"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Provincia"
              {...register("provincia")}
              error={errors.provincia ? true : false}
              onBlur={onProvinciaChange}
            />
            <Typography variant="inherit" color="red">
              {errors.provincia?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="ciudad"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Ciudad"
              {...register("ciudad")}
              error={errors.ciudad ? true : false}
              onBlur={onCiudadChange}
            />
            <Typography variant="inherit" color="red">
              {errors.ciudad?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="barrio"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Barrio"
              {...register("barrio")}
              error={errors.barrio ? true : false}
              onBlur={onBarrioChange}
            />
            <Typography variant="inherit" color="red">
              {errors.barrio?.message}
            </Typography>
          </div>

          <div>
            <TextField
              autoComplete="new-password"
              name="direccion"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Dirección"
              {...register("direccion")}
              error={errors.direccion ? true : false}
              onBlur={onDireccionChange}
            />
            <Typography variant="inherit" color="red">
              {errors.direccion?.message}
            </Typography>
          </div>

          <div>
            <TextField
              autoComplete="new-password"
              name="numerocasa"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Número de Casa"
              {...register("numerocasa")}
              error={errors.numerocasa ? true : false}
              onBlur={onNumeroCasaChange}
            />
            <Typography variant="inherit" color="red">
              {errors.numerocasa?.message}
            </Typography>
          </div>

          <div>
            <TextField
              autoComplete="new-password"
              name="pisodepartamento"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Piso o Departamento"
              {...register("pisodepartamento")}
              error={errors.pisodepartamento ? true : false}
              onBlur={onPisoChange}
            />
            <Typography variant="inherit" color="red">
              {errors.pisodepartamento?.message}
            </Typography>
          </div>

          <div>
            <TextField
              autoComplete="new-password"
              name="telefonoconvencional"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Teléfono Convencional"
              {...register("telefonoconvencional")}
              error={errors.telefonoconvencional ? true : false}
              onBlur={onTelefonoConvencionalChange}
            />
            <Typography variant="inherit" color="red">
              {errors.telefonoconvencional?.message}
            </Typography>
          </div>

          <div>
            <TextField
              autoComplete="new-password"
              name="telefonocelular"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Teléfono Celular"
              {...register("telefonocelular")}
              error={errors.telefonocelular ? true : false}
              onBlur={onTelefonoCelularChange}
            />
            <Typography variant="inherit" color="red">
              {errors.telefonocelular?.message}
            </Typography>
          </div>

          <div>
            <TextField
              autoComplete="new-password"
              name="codigopostal"
              style={{ width: "100%" }}
              id="outlined-required"
              label="Código Postal"
              {...register("codigopostal")}
              onBlur={onCodigoPostalChange}
            />
          </div>
        </SectionContainer3Columns>
        <TitleSection>
          Personas Expuestas Políticamente (PEP)
          <Divider />
        </TitleSection>
        <SectionContainer1Column>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Usted, desempeña o ha desempeñado funciones o cargos públicos
                  en el Ecuador o en el extranjero
                </InputLabel>
                <Select
                  style={{ width: "100%" }}
                  name="isCargoPublico"
                  label="Usted, desempeña o ha desempeñado funciones o cargos públicos en el Ecuador o en el extranjero"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("isCargoPublico")}
                  value={isCargoPublicoValue}
                  onChange={onIsCargoPublicoChange}
                >
                  <MenuItem value="Si">Si</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Usted es familiar de un PEP, en el 2do grado de consanguinidad
                  (padres/hijos/abuelos/nietos/cónyuge){" "}
                </InputLabel>
                <Select
                  style={{ width: "100%" }}
                  name="isFamiliarCargoPublico"
                  label="Usted es familiar de un PEP, en el 2do grado de consanguinidad (padres/hijos/abuelos/nietos/cónyuge)"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("isFamiliarCargoPublico")}
                  value={isFamiliarCargoPublicoValue}
                  onChange={onIsFamiliarCargoPublicoChange}
                >
                  <MenuItem value="Si">Si</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Usted trabaja políticamente con una personas expuesta
                  políticamente (PEP){" "}
                </InputLabel>
                <Select
                  style={{ width: "100%" }}
                  name="isTrabajaCargoPublico"
                  label="Usted trabaja políticamente con una personas expuesta políticamente (PEP) "
                  MenuProps={{ disableScrollLock: true }}
                  {...register("isTrabajaCargoPublico")}
                  value={isTrabajaCargoPublicoValue}
                  onChange={onIsTrabajaCargoPublicoValueChange}
                >
                  <MenuItem value="Si">Si</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
              <Typography>
                <strong> Nota: </strong>
              Si usted respondió si a una de las preguntas anteriores se le enviará el formulario PEP para que lo complete correctamente. Forma parte de nuestras políticas que las personas políticamente expuestas o relacionadas con ellas llenen este formulario.
              </Typography>
            </SectionContainer1Column>
        {/************* RESIDENCIA FISCAL *****************/}
        {isEcuadorian && (
          <>
            <TitleSection>
              Residencia Fiscal
              <Divider />
            </TitleSection>
            <SectionContainer2Columns>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    ¿Es una persona estadounidense para fines fiscales?
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="iseu"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select-helper"
                    label="¿Es una persona estadounidense para fines fiscales?"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("iseu")}
                    value={isEuValue}
                    onChange={onIsEuValueChange}
                  >
                    <MenuItem value="Si">Si</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </div>

              {isEu ? (
                <TextField
                  autoComplete="new-password"
                  name="snn"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Identificación del Contribuyente en SSN"
                  {...register("snn")}
                  onBlur={onIdentificacionContribuyenteSnnChange}
                />
              ) : (
                <>
                  <div>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel id="demo-simple-select-label">
                        ¿Es residente de cualquier otro país distinto de EU para
                        fines fiscales?
                      </InputLabel>
                      <Select
                        style={{ width: "100%" }}
                        id="demo-simple-select-helper"
                        label="¿Es residente de cualquier otro país distinto de EU para fines fiscales?"
                        MenuProps={{ disableScrollLock: true }}
                        value={isNoEuValue}
                        onChange={onIsNoEuChange}
                      >
                        <MenuItem value="Si">Si</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {isNoEu && (
                    <>
                      <TextField
                        autoComplete="new-password"
                        name="paisnoeu"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Escriba el Pais Residente"
                        {...register("paisnoeu")}
                        onBlur={onPaisNoEuChange}
                      />
                      <TextField
                        autoComplete="new-password"
                        name="snn"
                        style={{ width: "100%" }}
                        id="outlined-required"
                        label="Identificación del Contribuyente en SSN"
                        {...register("snn")}
                        onBlur={onIdentificacionContribuyenteSnnChange}
                      />
                    </>
                  )}
                </>
              )}
            </SectionContainer2Columns>
          </>
        )}
        {/************* INFORMACIÓN FINANCIERA *****************/}

        <TitleSection>
          Información Financiera
          <Tooltip
            title={
              <Typography fontSize={15}>
                Escriba un monto aproximado de sus activos y pasivos en los
                siguientes campos. En caso de no poseer, escriba el número 0.
              </Typography>
            }
            style={{ color: "#208037", fontSize: "30px" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            justifyItems: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {/* ***************** ACTIVOS ****************** */}
          <ActivePasiveText>Activos</ActivePasiveText>
        </div>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="cajabanco"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Caja / Bancos"
              {...register("cajabanco")}
              error={errors.cajabanco ? true : false}
              onBlur={onCajaBancosChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.cajabanco?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="valorautos"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Valor de Autos"
              {...register("valorautos")}
              error={errors.valorautos ? true : false}
              onBlur={onValorAutosChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.valorautos?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="valorinmuebles"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Valor de Inmuebles"
              {...register("valorinmuebles")}
              error={errors.valorinmuebles ? true : false}
              onBlur={onValorInmueblesChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.valorinmuebles?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="valorinversion"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Valor en Inversiones"
              {...register("valorinversion")}
              error={errors.valorinversion ? true : false}
              onBlur={onValorInversionesChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.valorinversion?.message}
            </Typography>
          </div>

          <TextField
            autoComplete="new-password"
            style={{
              width: "100%",
            }}
            disabled
            type="number"
            id="outlined-required"
            label="Total de Activos"
            value={totalActivosValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <div>
            <TextField
              autoComplete="new-password"
              name="ingresosmensuales"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Ingresos Mensuales"
              {...register("ingresosmensuales")}
              error={errors.ingresosmensuales ? true : false}
              onBlur={onIngresosMensualesChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.ingresosmensuales?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            justifyItems: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {/* ***************** PASIVOS ****************** */}
          <ActivePasiveText style={{ marginTop: "20px" }}>
            Pasivos
          </ActivePasiveText>
        </div>
        <SectionContainer3Columns>
          <div>
            <TextField
              autoComplete="new-password"
              name="tarjetas"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Tarjeta de Crédito"
              {...register("tarjetas")}
              error={errors.tarjetas ? true : false}
              onBlur={onTarjetaCreditoChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.tarjetas?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="hipotecas"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Hipotécas"
              {...register("hipotecas")}
              error={errors.hipotecas ? true : false}
              onBlur={onHipotecasChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.hipotecas?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="otros"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Otros"
              {...register("otros")}
              error={errors.otros ? true : false}
              onBlur={onOtrosChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.otros?.message}
            </Typography>
          </div>

          <TextField
            autoComplete="new-password"
            style={{
              width: "100%",
            }}
            disabled
            type="number"
            id="outlined-required"
            label="Total de Pasivos"
            value={totalPasivosValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <TextField
            autoComplete="new-password"
            style={{
              width: "100%",
            }}
            disabled
            type="number"
            id="outlined-required"
            label="Patrimonio"
            value={patrimonioValue}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <div>
            <TextField
              autoComplete="new-password"
              name="egresosmensuales"
              style={{
                width: "100%",
              }}
              type="number"
              id="outlined-required"
              label="Egresos Mensuales"
              {...register("egresosmensuales")}
              error={errors.egresosmensuales ? true : false}
              onBlur={onEgresosMensualesChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
            <Typography variant="inherit" color="red">
              {errors.egresosmensuales?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        <TitleSection>
          Cuentas Bancarias
          <Divider />
        </TitleSection>
        <CuentasContainer>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                # de Cuentas
              </InputLabel>
              <Select
                style={{ width: "50%" }}
                name="ncuentas"
                id="demo-simple-select-helper"
                labelId="demo-simple-select-label"
                label="# de Cuentas"
                MenuProps={{ disableScrollLock: true }}
                {...register("ncuentas")}
                error={errors.ncuentas ? true : false}
                value={nCuentasValue}
                onChange={onNCuentasChange}
              >
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.ncuentas?.message}
            </Typography>
          </div>
        </CuentasContainer>
        <SectionContainer3Columns>
          {isNCuentas && (
            //Cuenta 1
            <>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="institucion1"
                  style={{
                    width: "100%",
                  }}
                  id="outlined-required"
                  label="Institucion Financiera"
                  {...register("institucion1")}
                  onBlur={onInstitucionFinanciera1Change}
                />
              </div>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de Cuenta
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="tipocuenta1"
                    id="demo-simple-select-helper"
                    label="Tipo de Cuenta"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("tipocuenta1")}
                    value={tipoCuentaValue}
                    onChange={onTipoCuentaChange}
                  >
                    <MenuItem value="Corriente">Corriente</MenuItem>
                    <MenuItem value="Ahorro">Ahorro</MenuItem>
                    <MenuItem value="Inversion">Inversión</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="numerocuenta1"
                  style={{
                    width: "100%",
                  }}
                  type="number"
                  id="outlined-required"
                  label="Número de Cuenta"
                  {...register("numerocuenta1")}
                  onBlur={onNumeroCuenta1Change}
                />
              </div>
            </>
          )}
          {isNCuentas2 && (
            <>
              {/* Cuenta 1 */}
              <div>
                <TextField
                  autoComplete="new-password"
                  name="institucion1"
                  style={{
                    width: "100%",
                  }}
                  id="outlined-required"
                  label="Institucion Financiera"
                  {...register("institucion1")}
                  onBlur={onInstitucionFinanciera1Change}
                />
              </div>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de Cuenta
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="tipocuenta1"
                    id="demo-simple-select-helper"
                    label="Tipo de Cuenta"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("tipocuenta1")}
                    value={tipoCuentaValue}
                    onChange={onTipoCuentaChange}
                  >
                    <MenuItem value="Corriente">Corriente</MenuItem>
                    <MenuItem value="Ahorro">Ahorro</MenuItem>
                    <MenuItem value="Inversion">Inversión</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="numerocuenta1"
                  style={{
                    width: "100%",
                  }}
                  type="number"
                  id="outlined-required"
                  label="Número de Cuenta"
                  {...register("numerocuenta1")}
                  onBlur={onNumeroCuenta1Change}
                />
              </div>
              {/* Cuenta 2 */}
              <div>
                <TextField
                  autoComplete="new-password"
                  name="institucion2"
                  style={{
                    width: "100%",
                  }}
                  id="outlined-required"
                  label="Institucion Financiera"
                  {...register("institucion2")}
                  onBlur={onInstitucionFinanciera2Change}
                />
              </div>
              <div>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de Cuenta
                  </InputLabel>
                  <Select
                    style={{ width: "100%" }}
                    name="tipocuenta2"
                    id="demo-simple-select-helper"
                    label="Tipo de Cuenta"
                    MenuProps={{ disableScrollLock: true }}
                    {...register("tipocuenta2")}
                    value={tipoCuenta2Value}
                    onChange={onTipoCuenta2Change}
                  >
                    <MenuItem value="Corriente">Corriente</MenuItem>
                    <MenuItem value="Ahorro">Ahorro</MenuItem>
                    <MenuItem value="Inversion">Inversión</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="numerocuenta2"
                  style={{
                    width: "100%",
                  }}
                  type="number"
                  id="outlined-required"
                  label="Número de Cuenta"
                  {...register("numerocuenta2")}
                  onBlur={onNumeroCuenta2Change}
                />
              </div>
            </>
          )}
        </SectionContainer3Columns>
        <TitleSection>
          Perfil de Riesgo
          <Divider />
        </TitleSection>
        <SectionContainer1Column>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Objeto de la Inversión
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="objinversion"
                  id="demo-simple-select-helper"
                  label="Objeto de la Inversión"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("objinversion")}
                  error={errors.objinversion ? true : false}
                  value={objetoInversionValue}
                  onChange={onObjetoInversionChange}
                >
                  <MenuItem value="CortoPlazo">Corto Plazo</MenuItem>
                  <MenuItem value="MedianoPlazo">Mediano Plazo</MenuItem>
                  <MenuItem value="LargoPlazo">Largo Plazo</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.objinversion?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Ingresos económicos extras a corto, mediano o largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Necesidad de Liquidez
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="necesidadliquidez"
                  id="demo-simple-select-helper"
                  label="Necesidad de Liquidez"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("necesidadliquidez")}
                  error={errors.necesidadliquidez ? true : false}
                  value={necesidadLiquidezValue}
                  onChange={onNecesidadLiquidezChange}
                >
                  <MenuItem value="CortoPlazo">Corto Plazo</MenuItem>
                  <MenuItem value="MedianoPlazo">Mediano Plazo</MenuItem>
                  <MenuItem value="LargoPlazo">Largo Plazo</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.necesidadliquidez?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Depende de su necesidad elija a corto, mediano o largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Experiencia
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="experiencia"
                  id="demo-simple-select-helper"
                  label="Experiencia"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("experiencia")}
                  error={errors.experiencia ? true : false}
                  value={experienciaValue}
                  onChange={onExperienciaValue}
                >
                  <MenuItem value="Si">Si</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                  <MenuItem value="Media">Media</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.experiencia?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Elija el nivel de experiencia que tiene al momento de realizar
                  inversiones.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Plazo de la Inversión
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="plazoinversion"
                  id="demo-simple-select-helper"
                  label="Plazo de la Inversión"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("plazoinversion")}
                  error={errors.plazoinversion ? true : false}
                  value={plazoInversionValue}
                  onChange={onPlazoInversionChange}
                >
                  <MenuItem value="CortoPlazo">Corto Plazo</MenuItem>
                  <MenuItem value="MedianoPlazo">Mediano Plazo</MenuItem>
                  <MenuItem value="LargoPlazo">Largo Plazo</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.plazoinversion?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Depende de su disponibilidad de tiempo elija a corto, mediano
                  o largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">
                  Disponibilidad de Recursos
                </InputLabel>
                <Select
                  style={{ width: "300px" }}
                  name="disponibilidadrecursos"
                  id="demo-simple-select-helper"
                  label="Disponibilidad de Recursos"
                  MenuProps={{ disableScrollLock: true }}
                  {...register("disponibilidadrecursos")}
                  error={errors.disponibilidadrecursos ? true : false}
                  value={disponibilidadRecursosValue}
                  onChange={onDisponibilidadRecursosChange}
                >
                  <MenuItem value="Inmediato">Inmediato</MenuItem>
                  <MenuItem value="Programado">Programado</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="inherit" color="red">
                {errors.disponibilidadrecursos?.message}
              </Typography>
            </div>

            <Tooltip
              title={
                <Typography fontSize={15}>
                  Inmediato de acuerdo a cada inversionista. Programado para
                  inversiones a largo plazo.
                </Typography>
              }
              style={{ color: "#208037", fontSize: "30px" }}
              arrow
              placement="right"
            >
              <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
            </Tooltip>
          </div>
        </SectionContainer1Column>

        {/* ACÁ VA EL REPRESENTADO POR */}
        {isUnderage && (
          <>
            <TitleSection>
              Representado por:
              <Tooltip
                title={
                  <Typography fontSize={15}>
                    Al registrar a un menor de edad, se necesita conocer quién
                    lo representa.
                  </Typography>
                }
                style={{ color: "#208037" }}
                arrow
                placement="right"
              >
                <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
              </Tooltip>
              <Divider />
            </TitleSection>
            <SectionContainer3Columns>
              <div>
                <TextField
                  autoComplete="new-password"
                  name="representadopor"
                  style={{ width: "100%" }}
                  id="outlined-required"
                  label="Tipo de Representante"
                  {...register("representadopor")}
                  onBlur={onRepresentadoChange}
                />
              </div>
            </SectionContainer3Columns>
          </>
        )}

        <TitleSection>
          Firma
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir una imagen de su firma
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={firmaFileValue}
            onFilesChange={(value) => {
              setFirmaFileValue(value);
              setDisableIfUploadSignature(true);
            }}
            buttonText="Subir Firma"
            title="Firma"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*"}
            maxFileSize={10}
            disabled={disableIfMadeSignature ? true : false}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            O puede firmar directamente haciendo click en el botón FIRMAR AHORA
            <Popup
              modal
              trigger={
                <Button
                  style={{ marginTop: "22px" }}
                  variant="contained"
                  disabled={disableIfUploadSignature ? true : false}
                >
                  Firmar Ahora
                </Button>
              }
              closeOnDocumentClick={false}
            >
              {(close) => (
                <div>
                  <SignaturePad
                    penColor="black"
                    backgroundColor="white"
                    canvasProps={{
                      className: "sigCanvas",
                    }}
                    ref={sigCanvas}
                  />
                  {/* Button to trigger save canvas image */}
                  <br></br>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: "10px",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => {
                        save();
                        close();
                      }}
                    >
                      Guardar
                    </Button>
                    <Button variant="contained" onClick={clear}>
                      Limpiar
                    </Button>
                    <Button variant="contained" onClick={close}>
                      Cerrar
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        deleteSignature();
                        close();
                      }}
                    >
                      Eliminar Firma
                    </Button>
                  </div>
                </div>
              )}
            </Popup>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Asegúrate que tu firma esté similar a la cédula.
            {imageURL ? (
              <img
                src={imageURL}
                alt="Firmar Fiduvalor"
                style={{
                  display: "block",
                  margin: "0 auto",
                  border: "1px solid black",
                  width: "150px",
                }}
              />
            ) : (
              <p>No ha firmado</p>
            )}
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="nfirmante"
              style={{
                width: "100%",
              }}
              id="outlined-required"
              label="Nombre Completo del Firmante"
              {...register("nfirmante")}
              error={errors.nfirmante ? true : false}
              onBlur={onNombreCompletoFirmanteChange}
            />
            <Typography variant="inherit" color="red">
              {errors.nfirmante?.message}
            </Typography>
          </div>
          <div>
            <TextField
              autoComplete="new-password"
              name="cifirmante"
              style={{
                width: "100%",
              }}
              id="outlined-required"
              label="Cédula/Pasaporte del Firmante"
              {...register("cifirmante")}
              error={errors.cifirmante ? true : false}
              onBlur={onCedulaPasaporteFirmanteChange}
            />
            <Typography variant="inherit" color="red">
              {errors.cifirmante?.message}
            </Typography>
          </div>
        </SectionContainer3Columns>
        <TitleSection>
          Copia a color de cédula de ciudadanía
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia a color de la
                cédula de ciudadania requerida.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns style={{ rowGap: "0px" }}>
          <ActivePasiveText style={{ marginLeft: "0px", textAlign: "center" }}>
            Titular
          </ActivePasiveText>
          {isMarried ? (
            <ActivePasiveText
              style={{ marginLeft: "0px", textAlign: "center" }}
            >
              Cónyuge{" "}
            </ActivePasiveText>
          ) : (
            <div></div>
          )}
          <div></div>
          <FileUpload
            value={copiaCedulaTitularFileValue}
            onFilesChange={setCopiaCedulaTitularFileValue}
            buttonText="Subir Copia de Cédula "
            title="Copia de Cédula"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
          {isMarried && (
            <FileUpload
              value={copiaCedulaConyugeFileValue}
              onFilesChange={setCopiaCedulaConyugeFileValue}
              buttonText="Subir Copia de Cédula "
              title="Copia de Cédula"
              header="Arrastrar y soltar"
              multiFile={false}
              acceptedType={"image/*,.pdf"}
              maxFileSize={10}
              showPlaceholderImage={false}
              buttonRemoveLabel="Eliminar"
              rightLabel="para seleccionar archivos"
              leftLabel="o"
              buttonLabel="Click aquí"
              maxUploadFiles={1}
            />
          )}
        </SectionContainer3Columns>
        <TitleSection>
          Copia de la papeleta de votación
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia de la papeleta de
                votación requerida.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns style={{ rowGap: "0px" }}>
          <ActivePasiveText style={{ marginLeft: "0px", textAlign: "center" }}>
            Titular
          </ActivePasiveText>
          {isMarried ? (
            <ActivePasiveText
              style={{ marginLeft: "0px", textAlign: "center" }}
            >
              Cónyuge{" "}
            </ActivePasiveText>
          ) : (
            <div></div>
          )}

          <div></div>
          <FileUpload
            value={copiaPapeletaTitularFileValue}
            onFilesChange={setCopiaPapeletaTitularFileValue}
            buttonText="Subir Copia de Papeleta"
            title="Copia de Papeleta"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
          {isMarried && (
            <FileUpload
              value={copiaPapeletaConyugeFileValue}
              onFilesChange={setCopiaPapeletaConyugeFileValue}
              buttonText="Subir Copia de Papeleta"
              title="Copia de Papeleta"
              header="Arrastrar y soltar"
              multiFile={false}
              acceptedType={"image/*,.pdf"}
              maxFileSize={10}
              showPlaceholderImage={false}
              buttonRemoveLabel="Eliminar"
              rightLabel="para seleccionar archivos"
              leftLabel="o"
              buttonLabel="Click aquí"
              maxUploadFiles={1}
            />
          )}
        </SectionContainer3Columns>
        <TitleSection>
          Copia de la planilla de agua, luz o teléfono
          <Tooltip
            title={
              <Typography fontSize={15}>
                Subir un archivo en formato .pdf de la copia de la planilla de
                agua, luz o teléfono.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaPlanillasFileValue}
            onFilesChange={setCopiaPlanillasFileValue}
            buttonText="Subir Copia de Planillas"
            title="Copia de Planillas"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>
        <TitleSection>
          Copia de la Declaración del Impuesto a la Renta año inmediato anterior
          <Tooltip
            title={
              <Typography fontSize={15}>
                En caso de declarar impuestos, suba un archivo .pdf de la copia
                de la declaración de impuestos a la renta del año inmediato
                anterior.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <div>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id="demo-simple-select-label">
                ¿Declara Impuestos a la Renta?
              </InputLabel>
              <Select
                style={{ width: "100%" }}
                name="declaraimpuesto"
                id="demo-simple-select-helper"
                label="¿Declara Impuestos a la Renta?"
                MenuProps={{ disableScrollLock: true }}
                {...register("declaraimpuesto")}
                error={errors.declaraimpuesto ? true : false}
                value={declaraImpuestoValue}
                onChange={onDeclaraImpuestoChange}
              >
                <MenuItem value="Si">Si</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <Typography variant="inherit" color="red">
              {errors.declaraimpuesto?.message}
            </Typography>
          </div>

          {isDeclaring && (
            <>
              <div></div>
              <div></div>
              <FileUpload
                value={copiaDeclaracionImpuestosFileValue}
                onFilesChange={setCopiaDeclaracionImpuestosFileValue}
                buttonText="Subir Copia de Declaración"
                title="Copia de Declaración"
                header="Arrastrar y soltar"
                multiFile={false}
                acceptedType={"image/*,.pdf"}
                maxFileSize={10}
                showPlaceholderImage={false}
                buttonRemoveLabel="Eliminar"
                rightLabel="para seleccionar archivos"
                leftLabel="o"
                buttonLabel="Click aquí"
                maxUploadFiles={1}
              />
            </>
          )}
        </SectionContainer3Columns>
        <TitleSection>
          Certificado Bancario
          <Tooltip
            title={
              <Typography fontSize={15}>
                En caso de declarar impuestos, suba un archivo .pdf de la copia
                de la declaración de impuestos a la renta del año inmediato
                anterior.
              </Typography>
            }
            style={{ color: "#208037" }}
            arrow
            placement="right"
          >
            <HelpIcon style={{ color: "#208037", marginLeft: "10px" }} />
          </Tooltip>
          <Divider />
        </TitleSection>
        <SectionContainer3Columns>
          <FileUpload
            value={copiaCertificadoBancarioFileValue}
            onFilesChange={setCopiaCertificadoBancarioFileValue}
            buttonText="Subir Copia de Certificado Bancario"
            title="Copia de Certificado Bancario"
            header="Arrastrar y soltar"
            multiFile={false}
            acceptedType={"image/*,.pdf"}
            maxFileSize={10}
            showPlaceholderImage={false}
            buttonRemoveLabel="Eliminar"
            rightLabel="para seleccionar archivos"
            leftLabel="o"
            buttonLabel="Click aquí"
            maxUploadFiles={1}
          />
        </SectionContainer3Columns>

        <TitleSection>
          La información proporcionada en este formulario es correcta y
          completa.
          <Divider />
        </TitleSection>
        <SectionContainer2Columns>
          <TextField
            autoComplete="new-password"
            id="outlined-multiline-flexible"
            label="Términos"
            multiline
            maxRows={10}
            value={multilineValue}
            variant="outlined"
            disabled
          />
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  value={hasAccepted}
                  onChange={() => {
                    setHasAccepted(!hasAccepted);
                  }}
                />
              }
              label="Acepto y certifico que la información proporcionada es correcta y completa"
            />
          </div>
        </SectionContainer2Columns>

        <SectionContainer1Column>
          <Typography variant="body1" style={{ marginTop: "20px" }}>
            <span
              style={{
                color: "#208037",
                fontWeight: "bold",
              }}
            >
              NOTA:{" "}
            </span>
            Al enviar el formulario confirmo haber leído y aceptado los{" "}
            <span
              style={{
                color: "#208037",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                window.open(
                  "https://fiduvalor.com.ec/terminos-y-condiciones",
                  "_blank"
                );
              }}
            >
              términos y condiciones y política de privacidad de Fiduvalor{" "}
            </span>
            .
          </Typography>
        </SectionContainer1Column>

        <SectionContainer2Columns style={{ marginTop: "50px" }}>
          {hasAccepted && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <Button
                  sx={{
                    color: "black",
                    border: "2px solid #208037",
                    fontSize: "20px",
                    fontFamily: "Poppins",
                  }}
                  variant="outlined"
                  type="submit"
                >
                  Continuar
                </Button>
              </div>
            </>
          )}
        </SectionContainer2Columns>
      </form>
      <LoadingForm isLoading={isLoading} progress={progress} />
    </MainContainer>
  );
};

function LoadingForm(props) {
  const { progress, isLoading } = props;

  return (
    <Dialog
      open={isLoading}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{"¡Formulario Completado!"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          Gracias por confíar en FIDUVALOR. Nos encontramos envíando tu
          información, por favor espere unos segundos.
        </DialogContentText>
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
        >
          <CircularProgressWithLabel progress={progress} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

function CircularProgressWithLabel(props) {
  const { progress } = props;
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" value={progress} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default FormNaturalAll;
